module.exports = __webpack_public_path__ + "img/everybody_04.c850c166.png";